import { render, staticRenderFns } from "./DatasourceSelect.vue?vue&type=template&id=e050635c&scoped=true&"
import script from "./DatasourceSelect.vue?vue&type=script&lang=js&"
export * from "./DatasourceSelect.vue?vue&type=script&lang=js&"
import style0 from "./DatasourceSelect.vue?vue&type=style&index=0&id=e050635c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e050635c",
  null
  
)

export default component.exports